<!--
    by:hansan
-->
<template>

  <div  class="app-wrapper" :class="{fullheight: (ishideheader=='true'|| IFRAME_LOAD==1), crmfullheight: IFRAME_LOAD==1}">
    <navbar v-if="ishideheader!='true' && IFRAME_LOAD!=1"></navbar>
    <sidebar v-if="IFRAME_LOAD!=1" class="sideba" :size="sidebardefault" :sidebarType="sidebarType"></sidebar>
    <app-main class="app-main" :cutSize="maindefault"></app-main>
  </div>
</template>

<script>
    import { mapMutations } from 'vuex'
  import { Navbar,Sidebar, AppMain } from './components'
    export default {
        name: "index",
        data(){
          return{
            sidebardefault:"default",
            sidebarType:0,
            IFRAME_LOAD:0,
            maindefault:"zero",
            ishideheader:null
          }
        },
      inject: ['app'],
      watch:{
        $route(to,from){
            console.log(from.name)
            if(from.name != 'friendslist' && from.name != 'chat'){
                //组件销毁时清除chatlist
                this.SELECTCHAT({
                    records: [],
                    total:0
                })

                this.SELECTFRIEND({
                    wechatContactinfo: {
                        friendid: '',
                        wechatid: ''
                    }, //当前聊天好友信息
                    wechatMessage: {
                        lastmsgid: 0,
                        data: []
                    }
                })
            }
            // console.log("监听到路由变化",sidebarType)
         //根据路由控制侧边栏样式
          let {sidebarType} = to.meta;
          switch(sidebarType){
            case 1:
              this.sidebardefault = "small";
              this.maindefault="small"
              this.sidebarType = 1 ;
              break;
            case 2:
              this.sidebardefault = "small";
              this.maindefault="default"
              this.sidebarType = 2 ;
              break;
          }
        }
      },
        components: {
            Navbar,
            AppMain,
            Sidebar
        },
        methods:{
            ...mapMutations('im', [
                'SELECTCHAT',
                'SELECTFRIEND'
            ]),
        },
        created() {
            this.IFRAME_LOAD = this.$route.query.IFRAME_LOAD?this.$route.query.IFRAME_LOAD:window.sessionStorage.getItem("IFRAME_LOAD");
            this.ishideheader =this.$route.query.hideheader?this.$route.query.hideheader:sessionStorage.getItem('hideheader')
            console.log(this.IFRAME_LOAD==1,'IFRAME_LOAD')
            let {sidebarType} = this.$route.meta;
            switch(sidebarType){
                case 1:
                    this.sidebardefault = "small";
                    this.maindefault="small"
                    this.sidebarType = 1 ;
                    break;
                case 2:
                    this.sidebardefault = "small";
                    this.maindefault="default"
                    this.sidebarType = 2 ;
                    break;
            }
        },

    }
</script>

<style scoped>
  .sideba{
    float: left;
  }
  .app-main{
    float: right;
  }
</style>
<style lang="less">
    /* 样式覆盖 */
    .fullheight{
        .h-adaptive-w,.app-main,.content,.chat{
            height: 100vh !important;
        }
        .friendsList{
            height:calc(100vh - 15px)  !important;
        }
        .lists{
            height:calc(100vh - 68px)  !important;
        }
        .chatCon{
            // height:calc(100vh - 231px)  !important;
        }
        .cannosend {
            height: calc(100vh - 48px) !important;
        }
        .frame_box{
            height:calc(100vh - 2px)  !important;
        }
        .inspection_box,.operate_box,.person_friend{
          top:0!important;
          height: 100%!important;
          .inspection_box_cont,.operate_box_cont{
            height: 100%!important;
          }
          .slider_scroll{
            height: calc(100% - 60px)!important;
          }
        }

        .app-main{
          &>.talkSkill,&>.layout,&>.box,&>.sensitiveSetting{
            padding: 0;
          }
          &>.pointer_set_box{
            margin: 0;
          }
        }

        .gscontent,.h-adaptive{
          height: 100%!important;
        }
        .el-image-viewer__wrapper,.fiexd-sidebar {
            top: 0px!important;
        }
    }
    .crmfullheight {
      .app-main-small,.app-main-default{
        width: 100%!important;
      }
      .inspection_box,.operate_box,.person_friend{
        width: 100%!important;
        left: 0!important;
      }
      .operate_second_level{
        display: none;
      }
      .inspection_box_cont,.operate_box_cont,.powder_box {
        margin: 0!important;
        width: 100%!important;
      }
    }
	.hidden{
		visibility: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue